import React from 'react'
import { NavButton } from 'components'
import { useTranslation } from 'react-i18next'
import { SideBarNav } from 'components';

export const ProfesionalNav = () => {

    const { t } = useTranslation();

    return (
        <SideBarNav>
            <NavButton to="/patients" text={t('myPatients')} icon="ClinicalHistory" />
            {/* <Button className="mt-5" background type="link" to="/new-patient/demography">+ {t('newPatient')}</Button> */}
        </SideBarNav>
    )
}